import { render, staticRenderFns } from "./BlockPopupImageLeftTextRight.vue?vue&type=template&id=9d053ae8&"
import script from "./BlockPopupImageLeftTextRight.vue?vue&type=script&lang=js&"
export * from "./BlockPopupImageLeftTextRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports